import api from '@/api'

const { $pricing, $core, $student, $academic, $hubspot, $payment } = api;

export const { $studentProcessing, $preRegister, $type, $studentAccount, $studentToken} = $student;
export const { $contact } = $hubspot
export const { $careers, $ceos, $terms } = $academic
export const { $prices, $products, $types, $zones, $scholarships, $billingProps, $benefits, $discounts, $prepaids } = $pricing;
export const { $paymentMethod } = $payment
export const { $users, $cities, $citiesWithState, $countries, $nationalities, $citiesByState, $institutions } = $core;
